import React, { useEffect, useState } from 'react';
// import { useQuery, QueryClientProvider } from 'react-query';
// import { FixedSizeGrid } from 'react-window';
// import TextField from '@mui/material/TextField';
// import ListItem from '@mui/material/ListItem';
// import { queryClient } from '../../utils/queryClient';
import {
  AppBar, Box, ListItemButton, ListSubheader,
  // Paper, InputBase, IconButton,
  Typography, ListItemText, List, Link
} from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
import { getRandomStr } from '../../helpers';
import { useRouter } from 'next/router';

const getAlphabets = () => {
  const alphabets = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));
  // return ['All', ...alphabets];
  return alphabets;
};

// const filterFundsByAlphabet = (funds, selectedAlphabet) => {
//   if (selectedAlphabet === 'All') {
//     return funds;
//   }
//   return funds.filter((fund) => fund.n.startsWith(selectedAlphabet));
// };

// const filterStocksBySearch = (funds, searchQuery) => {
//   if (!searchQuery) {
//     return funds;
//   }
//   const query = searchQuery.toLowerCase();
//   return funds.filter((fund) => fund.n.toLowerCase().includes(query));
// };

const FundList = ({ fundData, sortedSections }) => {
  const router = useRouter();
  const { query } = router;
  const { alphabet } = query;

  // if (!fundData || !Array.isArray(fundData) || fundData.length === 0) {
  //   console.error('Invalid or empty data:');
  //   return <div>No valid data available.</div>;
  // }
  // const [selectedAlphabet, setSelectedAlphabet] = useState(alphabet || 'A');
  // const [searchQuery, setSearchQuery] = useState('');

  // // const { data: filteredFunds } = useQuery(['funds', selectedAlphabet, searchQuery], () => {
  // //   let result = filterFundsByAlphabet(fundData, selectedAlphabet);
  // //   result = filterStocksBySearch(result, searchQuery);
  // //   return result;
  // // });

  // useEffect(() => {
  //   setSelectedAlphabet(alphabet || 'A');
  // }, [alphabet]);

  useEffect(() => {
    if (!alphabet || !/^[a-zA-Z]$/.test(alphabet)) {
      router.push(`/browse/funds/a`);
    }
  }, []);

  // const filteredFunds = React.useMemo(() => {
  //   let result = filterFundsByAlphabet(fundData, selectedAlphabet);
  //   result = filterStocksBySearch(result, searchQuery);
  //   return result;
  // }, [fundData, selectedAlphabet, searchQuery]);

  // let groupedAndSorted;

  // try {
  //   groupedAndSorted = filteredFunds?.reduce((acc, item) => {
  //     let key;

  //     if (item && item.n) {
  //       const firstChar = item.n.charAt(0).toUpperCase();
  //       key = isNaN(firstChar) ? firstChar : '#'; // Check if it's a number
  //     } else {
  //       key = '#'; // Default to '#' if n is undefined or null
  //     }

  //     acc[key] = acc[key] || [];
  //     acc[key].push(item);
  //     return acc;
  //   }, {});

  //   for (const key in groupedAndSorted) {
  //     if (groupedAndSorted.hasOwnProperty(key)) {
  //       if (key === '#') {
  //         groupedAndSorted[key].sort((a, b) => a.n.localeCompare(b.n));
  //       } else {
  //         groupedAndSorted[key].sort((a, b) => a.n.localeCompare(b.n));
  //       }
  //     }
  //   }
  // } catch (error) {
  //   console.error('Error during grouping and sorting:', error);
  //   return <div style={{ textAlign: 'center', padding: '12rem 0' }}>Error occurred while processing data.<br />Please reload the page.</div>;
  // }

  // if (!groupedAndSorted) {
  //   console.error('Grouped and sorted data is undefined.');
  //   return <div style={{ textAlign: 'center', padding: '12rem 0' }}>Error occurred while sorting data.<br />Please reload the page.</div>;
  // }

  // const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
  //   if (a === '#') return -1; // '#' section should come first
  //   if (b === '#') return 1;
  //   return a.localeCompare(b); // Sort other sections alphabetically
  // });

  const alphabets = getAlphabets();

  const handleAlphabetClick = (alphabet) => {
    // setSelectedAlphabet(alphabet);
    router.push(`/browse/funds/${alphabet.toLowerCase()}`);
  };

  // const handleSearchChange = (event) => {
  //   setSearchQuery(event.target.value);
  // };

  return (
    <>
      <AppBar position="static" id="search-funds" sx={{ bgcolor: '#fff', }} elevation={0}>
        <Box sx={{ mt: 3, mx: 'auto', padding: '8px 8px 8px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
          <Typography color="#1d1d1f" variant="h1" sx={{ fontWeight: 500, fontSize: '1.4rem', lineHeight: 1, letterSpacing: '0.0075em', textTransform: 'capitalize' }}>
            Browse Funds
          </Typography>
          {alphabet &&
            <Typography variant="p" sx={{ mx: 0, fontWeight: 500, fontSize: '.9rem', color: 'rgb(96, 111, 123)', mt: 2 }}>
              {`The following list comprises companies that begin with the letter - ${alphabet?.toUpperCase()}`}
            </Typography>}
          {/* <Paper
            component="form"
            sx={{
              p: '2px 4px', display: 'flex', alignItems: 'center', width: 400,
              boxShadow: 0, border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.12)', borderRadius: '8px',
            }}
          >
            <InputBase
              size="small"
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{ mx: 1.5, flex: 1, pb: 0, lineHeight: 1, }}
              placeholder="Search Grufity Funds"
              inputProps={{ 'aria-label': 'search google maps' }}
            />
            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon />
            </IconButton>
          </Paper> */}
        </Box>
      </AppBar>
      <Box component="div" sx={{ display: 'flex', justifyContent: 'center', mx: { md: '60px', sm: '12px', xs: "12px" }, my: '60px', flexWrap: 'wrap' }}>
        {alphabets.map((a) => (
          <Typography
            key={getRandomStr(3)}
            variant="button"
            sx={{
              cursor: 'pointer', color: a.toLowerCase() === alphabet ? '#fff' : '#6e6e73', border: '1px solid', borderColor: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              fontWeight: a.toLowerCase() === alphabet ? 600 : 500, background: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              px: 1, py: .2, borderRadius: '8px', mr: 1,
              '&:hover': { borderColor: 'rgba(0, 0, 0, 0.12)' }
            }}
            onClick={() => handleAlphabetClick(a)}
          // href={`/browse/funds/${a.toLowerCase()}`}
          >
            {a}
          </Typography>
        ))}
      </Box>
      {/* <List dense={true}>
        <FixedSizeGrid
          columnCount={4}
          columnWidth={300}
          rowCount={Math.ceil(filteredFunds?.length / 4)}
          rowHeight={60}
          width={4 * 300}
          height={1200}
        >
          {renderStockItem}
        </FixedSizeGrid>

      </List> */}
      <List subheader={<li />}
        dense={true}
        sx={{
          '-webkit-column-count': { md: 4, sm: 2, xs: 1 },
          '-moz-column-count': { md: 4, sm: 2, xs: 1 },
          columnCount: { md: 4, sm: 2, xs: 1 },
          '-webkit-column-width': '4em',
          '-moz-column-width': '4em',
          columnWidth: '4em',
          '& .MuiListItemText-primary': { color: 'rgb(0 0 0 / 70%)', textTransform: 'capitalize' },
          '& a:hover .MuiListItemText-primary': { color: '#174ea6', },
          '& .MuiListItemText-primary .li-ticker': {
            color: 'rgb(0 0 0 / 70%)',
            fontWeight: 600, fontSize: '.8rem',
            display: 'none',
          },
          '& a:hover .li-ticker': { display: 'inline', ml: 'auto' }, mb: 17, '& ul': { p: '0 !important' }
        }}
      >
        {sortedSections?.map((alphabet) => (
          <li key={getRandomStr(7)} style={{ listStyle: 'none', margin: "0 0 1.5rem 0", display: 'block' }}>
            <ul>
              <ListSubheader sx={{ background: "transparent", fontWeight: 600, color: '#6e6e73', lineHeight: '24px', mb: 1.2 }}>{alphabet}</ListSubheader>
              {fundData[alphabet]?.map((item) => (
                <ListItemButton
                  target="_blank" rel="noopener noreferrer" component="a"
                  href={`/funds/${item.f}`} key={item.f} dense={true}
                  sx={{ '& .MuiListItemText-dense': { my: 0 }, borderRadius: '8px', }}
                >
                  <ListItemText primary={item.n} />
                </ListItemButton>
              ))}
            </ul>
          </li>
        ))}
      </List>
      <Box component="div" sx={{ display: 'flex', justifyContent: 'center', mx: { md: '60px', sm: '12px', xs: "12px" }, mb: '60px', flexWrap: 'wrap' }}>
        {alphabets.map((a) => (
          <Link
            underline="none"
            key={getRandomStr(3)}
            variant="button"
            sx={{
              cursor: 'pointer', color: a.toLowerCase() === alphabet ? '#fff' : '#6e6e73', border: '1px solid', borderColor: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              fontWeight: a.toLowerCase() === alphabet ? 600 : 500, background: a.toLowerCase() === alphabet ? '#174ea6' : '#fff',
              px: 1, py: .2, borderRadius: '8px', mr: 1,
              '&:hover': { borderColor: 'rgba(0, 0, 0, 0.12)' }
            }}
            // onClick={() => handleAlphabetClick(a)}
            href={`/browse/funds/${a.toLowerCase()}`}
          >
            {a}
          </Link>
        ))}
      </Box>
    </>
  );
};

// const FundListWithQueryProvider = (props) => (
//   <QueryClientProvider client={queryClient}>
//     <FundList {...props} />
//   </QueryClientProvider>
// );

// export default FundListWithQueryProvider;

export default FundList;
